export default {
  a: [
    '',
    'one ',
    'two ',
    'three ',
    'four ',
    'five ',
    'six ',
    'seven ',
    'eight ',
    'nine ',
    'ten ',
    'eleven ',
    'twelve ',
    'thirteen ',
    'fourteen ',
    'fifteen ',
    'sixteen ',
    'seventeen ',
    'eighteen ',
    'nineteen '
  ],
  b: [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety'
  ],
  getUniqueId () {
    return '_' + Math.random().toString(36).substr(2, 9)
  },
  convertNumberWithDecimal (amount) {
    let words = []
    words[0] = ''
    words[1] = 'One'
    words[2] = 'Two'
    words[3] = 'Three'
    words[4] = 'Four'
    words[5] = 'Five'
    words[6] = 'Six'
    words[7] = 'Seven'
    words[8] = 'Eight'
    words[9] = 'Nine'
    words[10] = 'Ten'
    words[11] = 'Eleven'
    words[12] = 'Twelve'
    words[13] = 'Thirteen'
    words[14] = 'Fourteen'
    words[15] = 'Fifteen'
    words[16] = 'Sixteen'
    words[17] = 'Seventeen'
    words[18] = 'Eighteen'
    words[19] = 'Nineteen'
    words[20] = 'Twenty'
    words[30] = 'Thirty'
    words[40] = 'Forty'
    words[50] = 'Fifty'
    words[60] = 'Sixty'
    words[70] = 'Seventy'
    words[80] = 'Eighty'
    words[90] = 'Ninety'
    amount = amount.toString()
    let atemp = amount.split('.')
    let numarray = (atemp[0]).match(/.{1,1}/g).reverse()
    let numarray2 = atemp[1] ? (atemp[1]).match(/.{1,1}/g).reverse() : undefined
    let part2text = ''
    let part3text = ''
    let part4text = ''

    let part0 = -1
    let part1 = 0
    let part3 = -1
    let totaltext = ''
    if (numarray[0]) {
      if (numarray[1]) {
        part1 = parseInt(numarray[1] + numarray[0])
      } else {
        part1 = parseInt(numarray[0])
      }

      if (part1 > 20) {
        totaltext = words[numarray[1] * 10] + ' ' + words[numarray[0]]
      } else {
        totaltext = words[part1]
      }

      if (numarray[2] > 0) {
        part2text = words[numarray[2]] + ' Hundred'
        totaltext = part2text + ' ' + totaltext
      }

      let checkifthousand = false
      if (numarray[4] !== undefined && numarray[3] !== undefined) {
        part3 = parseInt(numarray[4] + numarray[3])
      } else if (numarray[3] !== undefined) {
        part3 = parseInt(numarray[3])
      }

      if (part3 > 20) {
        part3text = words[numarray[4] * 10] + ' ' + words[numarray[3]]
      } else if (part3 > 0) {
        part3text = words[part3]
      }

      if (numarray[5] > 0) {
        part4text = words[numarray[5]] + ' Hundred'
      }

      if (part4text || part3text) {
        checkifthousand = true
      }
      let temptext = ''
      if (part4text) {
        temptext = part4text + ' '
      }
      if (part3text) {
        temptext = temptext + part3text + ' '
      }
      if (checkifthousand) {
        totaltext = temptext + 'Thousand ' + totaltext
      }

      let decimal
      if (numarray2) {
        if (numarray2[1]) {
          part0 = parseInt(numarray2[1] + numarray2[0])
        } else {
          part0 = parseInt(numarray2[0])
        }
        if (part0 > 20) {
          decimal = words[numarray2[1] * 10] + ' ' + words[numarray2[0]]
        } else {
          decimal = words[part0]
        }
      }
      if (decimal) {
        totaltext = totaltext + ' AND CENTS ' + decimal + ' ONLY'
      }
    }
    return totaltext.replace(/  +/g, ' ').toUpperCase()
  }
  // convertNumberWithDecimal (number) {
  //   let nums = number.toString().split('.')
  //   var whole = this.convertNumberToWords(nums[0])
  //   if (nums.length === 2) {
  //     let fraction = this.convertNumberToWords(nums[1])
  //     whole = whole.replace('and ', '')
  //     return (whole + 'and ' + fraction + 'ONLY').toUpperCase()
  //   } else {
  //     return (whole + 'ONLY').toUpperCase()
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/utils/common.js